'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const Canvas = dynamic(() => import('./_Canvas'), { ssr: false });
import Copy, { Props as ToutContentProps } from './_Copy';
import { Props as SequenceProps } from './_Canvas';

import { Section, Fixed, Absolute } from './styles';

interface Props {
  toutContent?: ToutContentProps;
  sequence?: SequenceProps;
  order?: number;
  _testID?: string;
}

const ScrollSequence = ({ sequence, toutContent, order, _testID }: Props) => {
  const ariaLabel = `${toutContent?.lilHeading} ${toutContent?.headingLine1} ${toutContent?.headingLine2}`;
  return (
    <Section
      className="scroll-section"
      order={order}
      portraitHeight={sequence?.mobileHeight}
      landscapeHeight={sequence?.desktopHeight}
      data-test-id={`scroll_sequence_${_testID}`}
    >
      <Absolute className="scroll-copy">
        <Copy {...toutContent} />
      </Absolute>

      <Fixed className="fixed">
        <Canvas {...sequence} ariaLabel={ariaLabel} />
      </Fixed>
    </Section>
  );
};

export default ScrollSequence;
